import request from '@/config/axios'

export const getCategoryPanelList = () => request.get({ url: '/rental/category-panel/list' })
export const getCategoryPanel = (id: number) =>
  request.get({ url: '/rental/category-panel/get', params: { id } })
export const createCategoryPanel = (data: any) =>
  request.post({ url: '/rental/category-panel/create', data })
export const updateCategoryPanel = (data: any) =>
  request.put({ url: '/rental/category-panel/update', data })
export const deleteCategoryPanel = (id: number) =>
  request.delete({ url: '/rental/category-panel/delete', params: { id } })
